import { xhrFetch } from "@origin-digital/daxi";
import { logger } from "@origin-digital/reporting-client";
import { formatQueryParameters } from "../helpers/url.helper";

const path = "/api/analytics/v1/track/feedback";

interface IFeedbackResponse {
  result: string;
  newEventId: string;
}

export interface IFeedbackParams {
  prevEventId?: string;
  feedbackType: string;
  feedbackText?: string;
  feedbackReason?: string;
  articleId: string;
  src: string;
  kb: string;
  visitorToken: string | undefined;
}

export const giveFeedback = async (
  host: string,
  params: IFeedbackParams
): Promise<any> => {
  try {
    const url = `${host}${path}?${formatQueryParameters(params)}`;
    const data = await xhrFetch<IFeedbackResponse>(encodeURI(url), {
      includeCommonHeaders: false,
    });
    return data;
  } catch (error) {
    logger.error("error giving feedback", error);
  }
  return {};
};
